import { CoreComponentListKey, CoreComponentListType, CoreComponentTypes } from './types.core';
import { ReactCommonRegistry } from './ReactCommonRegistry';
import { ReactCoreRegistry } from './ReactCoreRegistry';
import { JrComponentListKey, JrComponentListType, JrComponentTypes } from './types.common';

export interface RegistryComponents {
    [key: string]: any;
}

export class GlobalRegistry {
    commonRegistry: ReactCommonRegistry;
    coreRegistry: ReactCoreRegistry;

    constructor(commonRegistry: ReactCommonRegistry, coreRegistry: ReactCoreRegistry) {
        this.commonRegistry = commonRegistry;
        this.coreRegistry = coreRegistry;
    }

    public getLazyComponent<T extends CoreComponentListKey | JrComponentListKey>(
        name: T,
    ): (CoreComponentTypes & JrComponentTypes)[(CoreComponentListType & JrComponentListType)[T]] {
        if (this.commonRegistry.list[name]) {
            return this.commonRegistry.list[name];
        } else if (this.coreRegistry.list[name]) {
            return this.coreRegistry.list[name];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.error(`/!\\ COMPONENT ${name} NOT EXPORTED IN THE CORE BUNDLE /!\\`);
        }
        return this.commonRegistry.list['empty'];
    }
}
